import React from "react";
import { FormControl } from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { setMunicipalRegistry } from "../../../company-data/actions";
import { Input } from "@inspinia-react/form/input";

class MunicipalRegistry extends React.Component {
  constructor(props) {
    super(props);
    this._onChange = this._onChange.bind(this);
  }
  _onChange(e) {
    let text = e.replace(/\D/g, "")
    if (text.length < 21) {
      this.props.setMunicipalRegistry(text);
    }
  }
  render() {
    const { municipalRegistry, loading } = this.props;

    return (
      <div className="d-none">
        <div data-company-data className="py-2">
          <div style={{justifyContent: 'space-between'}} className='row col-12'>
            <div>
              Inscrição Municipal (IM)
            </div>
            <div>{municipalRegistry.length || 0}/20</div>
          </div>
          <Input
            value={municipalRegistry}
            placeholder="Número da inscrição municipal"
            onChange={this._onChange} 
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  municipalRegistry: state.municipalRegistry,
  loading: state.loading,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ setMunicipalRegistry }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MunicipalRegistry);



// WEBPACK FOOTER //
// ./src/components/parts/person/personAdaptToCompany/municipalRegistry/index.jsx